import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import event from '../views/event/event.vue'
import isiEvent from '../views/event/isiEvent.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import produkHukum from '../views/profil/produkHukum.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import sejarah from '../views/profil/sejarah.vue'
import tugasPokok from '../views/profil/tugasPokok.vue'
import visiMisi from '../views/profil/visiMisi.vue'
import bidangEkraf from '../views/unitKerja/bidangEkraf.vue'
import bidangPariwisata from '../views/unitKerja/bidangPariwisata.vue'
import uptd from '../views/unitKerja/uptd.vue'
import jabfung from '../views/unitKerja/jabfung.vue'
import sekretariat from '../views/unitKerja/sekretariat.vue'
import dikelolaPemda from '../views/pariwisata/dikelolaPemda.vue'
import dikelolaSwasta from '../views/pariwisata/dikelolaSwasta.vue'
import dikelolaMasyarakat from '../views/pariwisata/dikelolaMasyarakat.vue'
import kelompokUnggulan from '../views/ekraf/kelompokUnggulan.vue'
import produkUnggulan from '../views/ekraf/produkUnggulan.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/event',
    name: 'event',
    component: event
  },
  {
    path: '/isiEvent',
    name: 'isiEvent',
    component: isiEvent
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/produkHukum',
    name: 'produkHukum',
    component: produkHukum
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/sejarah',
    name: 'sejarah',
    component: sejarah
  },
  {
    path: '/tugasPokok',
    name: 'tugasPokok',
    component: tugasPokok
  },
  {
    path: '/visiMisi',
    name: 'visiMisi',
    component: visiMisi
  },
  {
    path: '/bidangEkraf',
    name: 'bidangEkraf',
    component: bidangEkraf
  },
  {
    path: '/bidangPariwisata',
    name: 'bidangPariwisata',
    component: bidangPariwisata
  },
  {
    path: '/uptd',
    name: 'uptd',
    component: uptd
  },
  {
    path: '/jabfung',
    name: 'jabfung',
    component: jabfung
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: sekretariat
  },
  {
    path: '/dikelolaPemda',
    name: 'dikelolaPemda',
    component: dikelolaPemda
  },
  {
    path: '/dikelolaSwasta',
    name: 'dikelolaSwasta',
    component: dikelolaSwasta
  },
  {
    path: '/dikelolaMasyarakat',
    name: 'dikelolaMasyarakat',
    component: dikelolaMasyarakat
  },
  {
    path: '/kelompokUnggulan',
    name: 'kelompokUnggulan',
    component: kelompokUnggulan
  },
  {
    path: '/produkUnggulan',
    name: 'produkUnggulan',
    component: produkUnggulan
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
